import { CmsApiStickyHeaderLinksBlockData } from 'modules/cms/api/types/CmsApiStickyHeaderLinks';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsAmpLinksBlock } from 'modules/cms/blocks/Amp/CmsAmpLinksBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsStickyHeaderLinksBlock } from './CmsStickyHeaderLinksBlock';

export const CmsStickyHeaderLinksBlockMapping: CmsBlockMapping<CmsApiStickyHeaderLinksBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: CmsBlockWidth.FULL,
    Component: CmsStickyHeaderLinksBlock,
    AmpComponent: CmsAmpLinksBlock,
  };
